import { Body } from "@sprout/typography";
import type { ProfileData } from "@/queries/use_profile.ts";

type Props = {
  data: ProfileData;
};

const AboutYouBody = ({ data }: Props) => <Body className="whitespace-pre-line">{data.bio}</Body>;

export default AboutYouBody;
